<template>
  <!-- 車隊專屬-->
  <div
    id="team"
    class="tab-pane fade in"
    :class="{ active: vx_activeTab === 'team' }"
    role="tabpanel"
  >
    <div class="table-responsive">
      <table class="table table-striped jambo_table bulk_action">
        <thead>
          <tr class="headings fontSize14">
            <th
              class="column-title word_center sort-header"
              width="40px"
              @click="onSort('createdAt')"
            >
              序號
              <span v-if="isCreatedAtAsc">▲</span>
              <span v-else>▼</span>
            </th>
            <th class="column-title word_center" width="50px">預約種類</th>
            <th class="column-title word_center" width="100px">
              司機隊編/呼號
            </th>
            <th
              class="column-title word_center sort-header"
              width="160px"
              @click="onSort('reservationTime')"
            >
              預約時間
              <span v-if="isReservationTimeAsc">▲</span>
              <span v-else>▼</span>
            </th>
            <th class="column-title word_center" width="110px">
              客服/進線電話
            </th>
            <th class="column-title word_center" width="200px">上車地址</th>
            <th class="column-title word_center" width="200px">下車地址</th>
            <th class="column-title word_center" width="180px">上車備註</th>
            <th class="column-title word_center" width="180px">乘客備註</th>
            <th
              class="column-title word_center"
              width="80px"
              v-if="vx_task === 'limitTime'"
            >
              一小時提醒
            </th>
            <th class="column-title word_center" width="80px">目前進度</th>
            <th class="column-title word_center" width="50px">應徵司機</th>
            <th class="column-title word_center" width="30px">檢視</th>
            <th class="bulk-actions" colspan="7">
              <a class="antoo">
                Bulk Actions (
                <span class="action-cnt" />
                )
                <i class="fa fa-chevron-down" />
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="row in vx_teamList">
            <tr
              class="pointer fontSize14"
              style="text-align: center"
              :key="row.billInfo.orderId"
            >
              <td>{{ row.billInfo.orderId }}</td>
              <td>
                {{ getReservationTypeText(row.billInfo.reservationType) }}
              </td>
              <td>
                <template v-if="row.driverInfo">
                  <div>{{ row.driverInfo.callNumber }}</div>
                  <div>{{ row.driverInfo.licence }}</div>
                </template>
              </td>

              <td>
                {{ row.billInfo.reservationTime }} ({{
                  day(row.billInfo.reservationTime)
                }})
              </td>
              <td>{{ noteProcess(row) }}</td>
              <td>{{ row.billInfo.onLocation }}</td>
              <td>{{ row.billInfo.offLocation }}</td>
              <td>
                {{ row.billInfo.passengerOnLacatioNote }}
              </td>
              <td>{{ row.billInfo.passengerNote }}</td>
              <td
                v-if="vx_task === 'limitTime'"
                :class="{ 'non-confirm': !row.driverInfo.isReply }"
              >
                {{ row.driverInfo.isReply ? '已確認' : '未確認' }}
              </td>
              <td>{{ orderState(row) }}</td>
              <td>{{ row.driverApply.total }}</td>
              <td>
                <button
                  @click="$emit('openModal', row.billInfo.orderId)"
                  class="mybtnstyle btn-danger"
                >
                  檢視
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { getDay } from '@/utils/helper'

export default {
  data() {
    return {
      isCreatedAtAsc: false,
      isReservationTimeAsc: false,
    }
  },
  methods: {
    ...mapMutations('reservation', {
      vx_setSort: 'setSort',
      vx_setSortStatus: 'setSortStatus',
      vx_setTeamPagingCurrentPage: 'setTeamPagingCurrentPage',
    }),
    ...mapActions('reservation', {
      vx_fetchList: 'fetchList',
    }),
    orderState(row) {
      if (row.billInfo.driverCancel) {
        return '司機取消'
      } else if (row.billInfo.passengerCancel) {
        return '乘客取消'
      } else if (row.billInfo.result === 1) {
        return '已載客'
      } else if (row.billInfo.result === 2) {
        return '完成'
      } else if (row.billInfo.result === 3) {
        return '未配對完'
      } else if (row.billInfo.result === 4) {
        return '等候乘客選擇司機'
      } else if (row.billInfo.result === null) {
        return '尚未有司機接單'
      }
      return '已配對'
    },
    day(val) {
      return getDay(val)
    },
    onSort(sortBy) {
      this.vx_setSort(sortBy)
      if (sortBy === 'createdAt') {
        this.isCreatedAtAsc = !this.isCreatedAtAsc
        this.vx_setSortStatus(this.isCreatedAtAsc ? 'asc' : 'desc')
      } else {
        this.isReservationTimeAsc = !this.isReservationTimeAsc
        this.vx_setSortStatus(this.isReservationTimeAsc ? 'asc' : 'desc')
      }
      this.vx_setTeamPagingCurrentPage(1)
      this.vx_fetchList()
    },
    noteProcess(row) {
      if (
        row.billInfo.passengerName === null ||
        row.serviceInfo.name === null
      ) {
        return '---'
      } else {
        return (
          (row.serviceInfo.name ? row.serviceInfo.name : row.managerInfo.name) +
          '-' +
          row.billInfo.passengerName +
          '-' +
          row.billInfo.passengerPhone
        )
      }
    },
    getReservationTypeText(type) {
      if (type === 0) {
        return '一般預約'
      } else if (type === 1) {
        return 'LINE預約'
      } else if (type === 2) {
        return '機場接送'
      }
      return '未知類型'
    },
  },
  computed: {
    ...mapState('reservation', {
      vx_activeTab: 'activeTab',
      vx_task: 'task',
      vx_teamList: 'teamList',
    }),
  },
}
</script>

<style scoped>
tr > td {
  color: black;
}
.non-confirm {
  color: red;
}
.sort-header:hover {
  cursor: pointer;
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/pages/reservation/components/Team.vue